module.exports = __webpack_public_path__ + "img/success.caaa55a5.png";